import { render, staticRenderFns } from "./ManageGroups.vue?vue&type=template&id=50708420&scoped=true&"
import script from "./ManageGroups.vue?vue&type=script&lang=js&"
export * from "./ManageGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50708420",
  null
  
)

export default component.exports